


































































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubRepositoryCommit} from '@/model/resource/GithubRepositoryCommit'
import moment from 'moment'

@Component({})
export default class CDLastCommitCard extends Vue {
  @Prop({type: GithubRepositoryCommit, required: true})
  commit!: GithubRepositoryCommit

  get authorAvatarUrl() {
    return this.commit.githubUser && this.commit.githubUser.avatarUrl
      ? this.commit.githubUser.avatarUrl
      : null
  }

  get authorLogin() {
    return this.commit.githubUser && this.commit.githubUser.login
      ? this.commit.githubUser.login
      : 'unknown'
  }

  get organizationName(): string {
    return this.commit.githubRepository?.githubOrganization?.name || 'N/A'
  }

  get repositoryName(): string {
    return this.commit.githubRepository?.name || 'N/A'
  }

  get organizationDotStyle(): string {
    const color = this.commit.githubRepository?.githubOrganization?.colorHex
    return color ? `background-color: #${color}` : ''
  }

  get committedLabel(): string {
    return this.commit.committedAt
      ? `committed ${moment(this.commit.committedAt).fromNow()}`
      : 'N/A'
  }

  formatUrl(url: string) {
    const urlFormatted = url
      ? url.replace('https://api.github.com/repos/', 'https://github.com/')
      : ''

    return urlFormatted.replace('commits/', 'commit/')
  }
}
